import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./index.css";
import { Toaster } from "react-hot-toast";
import Scrolltotop from "./components/UI/ScrollToTop";
import { RequireAuth } from "./Utils/RequireAuth";
import {
  Register,
  Login,
  Settings,
  ForgotPassword,
  AdminDashboard,
  Podcasters,
  SecretSignUp,
} from "./Pages";

const App = () => {
  return (
    <div className="w-full h-full text-sm sm:text-[15px] font text-zinc-700">
      <div>
        <Toaster
          toastOptions={{
            duration: 5000,
            position: "top-center",
            success: {
              style: {
                background: "#222",

                color: "#fff",
              },
            },
            error: {
              duration: 5000,
              position: "top-center",
              style: {
                background: "red",
                color: "#fff",
              },
            },
          }}
        />
      </div>
      <Router>
        <Scrolltotop />

        <Routes>
          {/*    AUTH PAGE */}

          <Route exact path="/" element={<Login />} />
          {/*    LANDING PAGE  */}

          <Route exact path="/forgot-password" element={<ForgotPassword />} />

          {/**Protected routes */}
          <Route
            path="/dashboard"
            element={
              <RequireAuth link={"/"}>
                <AdminDashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/users"
            element={
              <RequireAuth link={"/"}>
                <Podcasters />
              </RequireAuth>
            }
          />
          <Route
            path="/secret-signup"
            element={
              <RequireAuth link={"/"}>
                <SecretSignUp />
              </RequireAuth>
            }
          />
        </Routes>
      </Router>
    </div>
  );
};

export default App;
